import { Link } from "@mui/material";
import axios from "axios";
import { Component } from "react";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import Header from "../header";
import { apiCall_domain } from "../api";
import { PulseLoader } from "react-spinners";

class CancelOrder extends Component {
  state = {
    detail: [],
    active: false,
    loading: false,
    installment: {},
    commentOpen: false,
    reportOpen: false,
    anchorEl: null,
    reasonType: null,
    reason: null,
    cancelDisabled: true,
    options: [
      { title: "غرفه دار پاسخگو نیست", type: "vendor_no_response" },
      {
        title: "قصد استفاده از کد تخفیف در سفارش را دارم",
        type: "to_add_discount",
      },
      { title: "محصول با قیمت پایین تر پیدا کردم", type: "found_lower_price" },
      { title: "با غرفه دار به توافق نرسیدم", type: "disagreement_vendor" },
      { title: "تمایل به ویرایش/تغییر سفارش دارم", type: "want_edit_order" },
      { title: "زمان آماده سازی محصول طولانی است", type: "long_process_time" },
      { title: "مشکلات دیگر", type: "other" },
    ],
  };
  cancelOrders = (order_id, data) => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };

    return axios.post(
      `${apiCall_domain}/customer/orders/${order_id}/cancel`,
      data,
      {
        headers: headers,
      },
    );
  };
  handleReasonDescription = (e) => {
    if (this.state.reasonType === "other") {
      this.setState({
        cancelDisabled: false,
      });
    }
    this.setState({
      reason: e.target.value,
    });
  };
  handleReasonChange = (e) => {
    if (e.value !== "other") {
      this.setState({
        cancelDisabled: false,
      });
    }
    this.setState({
      reasonType: e.value,
    });
  };
  render() {
    return (
      <>
        <Header
          showSearchBar={true}
          title={` لغو سفارش  ${this.props.match.params.id}`}
          backUrl="/profile/myOrders"
        />
        <div className={"cancelOrderPopUp"}>
          <div className={"modalBody"}>
            <div className={"reasonSection"}>
              <span className={"title"}>دلیل لغو سفارش خود را انتخاب کنید</span>
              <ReactSelect
                components={{
                  IndicatorSeparator: () => null,
                }}
                className={"reasonDropBox"}
                value={this.state.state}
                onChange={(e) => this.handleReasonChange(e)}
                placeholder="انتخاب کنید"
                noOptionsMessage={() => "در حال لود ... "}
                options={this.state.options.map((option) => ({
                  value: option.type,
                  label: option.title,
                }))}
              />
            </div>
            <div className={"reasonSection"}>
              <span className={"title"}>دلیل لغو سفارش خود را توضیح دهید</span>
              <textarea
                placeholder="شرح دهید"
                onChange={(e) => this.handleReasonDescription(e)}
              ></textarea>
            </div>
            <p>
              تذکر : لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و
              با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و
              مجله در ستون و سطرآنچنان که لازم است{" "}
            </p>
            <p>
              1.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است{" "}
            </p>
            <p>
              2.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است{" "}
            </p>
          </div>
          <div className={"buttons"}>
            <button
              onClick={() => {
                const data = {
                  cancel_reason: this.state.reasonType,
                  cancel_reason_description: this.state.reason,
                };
                if (!this.state.cancelDisabled) {
                  this.setState({ loading: true });
                  this.cancelOrders(this.props.match.params.id, data)
                    .then(() => {
                      toast.success("سفارش شما لغو شد");
                      this.location.reload();
                    })
                    .catch((err) => {
                      toast.error(err.response.data.message);
                    })
                    .finally(() => {
                      this.setState({ loading: true });
                    });
                } else {
                  toast.error("فیلد های مورد نظر را پر کنید");
                }
              }}
            >
              {this.state.loading ? <PulseLoader color="white" /> : "تایید"}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default CancelOrder;
